var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavatarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18961",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18961",
    transform: "translate(-3804 18250)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17430",
    "data-name": "\\u9577\\u65B9\\u5F62 17430",
    width: 38,
    height: 38,
    transform: "translate(3804 -18250)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-magic-2931151",
    transform: "translate(3733.37 -18261.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28459",
    "data-name": "\\u30D1\\u30B9 28459",
    d: "M450.541,292.064l-3.216-.908a.486.486,0,0,1-.378-.378l-.908-3.216a.566.566,0,0,0-1.1,0l-.908,3.216a.486.486,0,0,1-.378.378l-3.216.908a.566.566,0,0,0,0,1.1l3.216.908a.486.486,0,0,1,.378.378l.908,3.216a.566.566,0,0,0,1.1,0l.908-3.216a.486.486,0,0,1,.378-.378l3.216-.908A.577.577,0,0,0,450.541,292.064Z",
    transform: "translate(-344.308 -254.817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28460",
    "data-name": "\\u30D1\\u30B9 28460",
    d: "M156.917,92.683l3.216.908a.486.486,0,0,1,.378.378l.908,3.216a.566.566,0,0,0,1.1,0l.908-3.216a.486.486,0,0,1,.378-.378l3.216-.908a.566.566,0,0,0,0-1.1l-3.216-.908a.486.486,0,0,1-.378-.378l-.908-3.216a.566.566,0,0,0-1.1,0l-.908,3.216a.486.486,0,0,1-.378.378l-3.216.908A.577.577,0,0,0,156.917,92.683Z",
    transform: "translate(-79.965 -67.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28461",
    "data-name": "\\u30D1\\u30B9 28461",
    d: "M422.357,19.883l3.216.908a.486.486,0,0,1,.378.378l.908,3.216a.566.566,0,0,0,1.1,0l.908-3.216a.486.486,0,0,1,.379-.378l3.216-.908a.566.566,0,0,0,0-1.1l-3.216-.908a.486.486,0,0,1-.379-.378l-.908-3.216a.566.566,0,0,0-1.1,0l-.908,3.216a.486.486,0,0,1-.378.378l-3.216.908a.577.577,0,0,0,0,1.1Z",
    transform: "translate(-327.473 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28462",
    "data-name": "\\u30D1\\u30B9 28462",
    d: "M98.732,264.65a1.12,1.12,0,0,0,0,1.551l1.7,1.7a1.12,1.12,0,0,0,1.551,0l16.57-16.57L115.3,248.08Z",
    transform: "translate(-25.789 -218.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_28463",
    "data-name": "\\u30D1\\u30B9 28463",
    d: "M379.71,191.715l-1.7-1.7a1.12,1.12,0,0,0-1.551,0l-1.816,1.816,3.253,3.253,1.816-1.816A1.12,1.12,0,0,0,379.71,191.715Z",
    transform: "translate(-283.351 -163.963)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavatarIcon);
export default __webpack_public_path__ + "static/media/favatarIcon.29717e2a642880c87856b85eb178f10f.svg";
export { ForwardRef as ReactComponent };